import type { IdentityContext } from "@utils/store/user/useUser";

/**
 * 從使用者的瓦斯帳戶清單中，挑出「瓦斯帳戶邀請」入口該用哪一個。
 *
 * 優先挑 role === "owner" 的帳戶：這個入口的唯一用途是邀請他人加入，
 * 而只有 owner 能產生邀請碼，挑到非 owner 的帳戶等於必定失敗。
 * owner 帳戶有多個時，沿用全站既有的優先序（目前選中的 → default → 第一個）。
 * 完全沒有 owner 帳戶時回傳依同一優先序挑出的帳戶，讓既有頁面自行提示；
 * 清單為空則回 null。
 */
export const pickInviteContext = (
  contexts: IdentityContext[],
  defaultContextId?: number | string | null,
  current?: IdentityContext | null,
): IdentityContext | null => {
  if (!contexts?.length) return null;

  const ownerContexts = contexts.filter((c) => c.role === "owner");
  const pool = ownerContexts.length > 0 ? ownerContexts : contexts;

  const savedContext = pool.find((c) => c.context_id === current?.context_id);
  // default_context_id 可能是 number 或 string，比對要容錯
  const defaultContext = pool.find((c) => String(c.context_id) === String(defaultContextId));

  return savedContext || defaultContext || pool[0];
};
